import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const HiddenSSR = ({ children, hidden, visible }) => {
  return (
    <motion.div style={{ display: (!visible || hidden) && 'none' }}>
      {children}
    </motion.div>
  )
}

export default HiddenSSR
